"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var withTooltip_1 = __importDefault(require("relements/build/esm/overlays/withTooltip"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var augmentation_in_progress_svg_1 = __importDefault(require("@src/components/Icon/augmentation-in-progress.svg"));
var _utils_1 = require("@src/actions/_utils");
var const_1 = require("@src/const");
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
require("./TransferButton.scss");
var TransferButton = function (_a) {
    var isAugmentationInProgress = _a.isAugmentationInProgress, trainingStarted = _a.trainingStarted, domainName = _a.domainName, needsTraining = _a.needsTraining, onTransferClick = _a.onTransferClick, onStatusIconClick = _a.onStatusIconClick;
    var meta = CommonStore_1["default"].getMetaTags();
    /**
     * We'll show the blue status icon when the augment process is in progress.
     */
    var getAugmentationStatusIcon = function () {
        if (isAugmentationInProgress)
            return augmentation_in_progress_svg_1["default"];
        return null;
    };
    var handleStatusClick = function () {
        // Open TransferModal
        onStatusIconClick();
        if (isAugmentationInProgress) {
            // Send event that the status icon is clicked
            _utils_1.sendGoogleAnalyticsEvents(const_1.GOOGLE_ANALYTICS.CATEGORY.SMART_VARIANTS, const_1.GOOGLE_ANALYTICS.EVENTS.BLUE_STATUS_ICON_CLICKED, "domain-" + domainName, const_1.GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK);
        }
    };
    var button_is_disabled = trainingStarted !== undefined ? needsTraining || trainingStarted : true;
    var tooltip = '';
    if (trainingStarted)
        tooltip = 'Training in Progress';
    if (needsTraining)
        tooltip = 'Please train the bot first to include new changes.';
    return (react_1["default"].createElement("div", { className: "transferButton" },
        react_1["default"].createElement(withTooltip_1["default"], { tooltip: tooltip, position: "BOTTOM" },
            react_1["default"].createElement(button_1["default"], { type: button_1["default"].TYPES.OUTLINE, onClick: onTransferClick, size: "big", secondaryIcon: getAugmentationStatusIcon(), onSecondaryIconClick: handleStatusClick, disabled: button_is_disabled }, "Publish"))));
};
exports["default"] = TransferButton;
